import "src/styles/resultados.scss";
import React, { useState, useEffect, useCallback, useMemo } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  recuperaResultado,
  recuperaResultadoTipoConcurso,
} from "src/reducers/relatorios/resultadosActions";
import { Sistema_ID } from "src/modules/constants";

import ResultContainer from "./result-container";
import moment from "moment/moment";
import { getSuperTimeIcon } from "src/utils/getSuperTimeIcon";
import { forceInt } from "../../utils/forceInt";

function Resultados({ type = "loteria-popular", selectedContest }) {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.usuario.objUser);
  const resultados = useSelector((state) => state.resultados.resultadoJBWeb);
  const isLoading = useSelector((state) => state.resultados.isLoading);

  const [currentDate, setCurrentDate] = useState(new Date());

  const handleSearchResult = useCallback((date) => {
    const transaction = {
      Sistema_ID: Sistema_ID,
      Cliente_ID: user.Cliente_ID,
      Site_ID: forceInt(user.Site_ID),
      CID: user.CID,
      chrSerial: user.ChrSerial,
      strData: moment(date).format("YYYY-MM-DD"),
    };

    dispatch(recuperaResultado(transaction, () => { }, true));
  }, []);

  const handleSearchTypeContest = useCallback(
    (date) => {
      const transaction = {
        date: moment(date).format("YYYY-MM-DD"),
        gameType: selectedContest.objTipoJogo.sntTipoJogo,
        isPopular: false,
        force: true,
        Cliente_ID: user.Cliente_ID,
        Site_ID: forceInt(user.Site_ID),
        CID: user.CID,
      };

      dispatch(recuperaResultadoTipoConcurso(transaction, () => { }, true));
    },
    [selectedContest, type]
  );

  const onRefresh = useCallback(() => {
    if (!["loteria-popular", "rifa"].includes(type)) {
      handleSearchTypeContest(currentDate);
    } else {
      handleSearchResult(currentDate);
    }
  }, [currentDate, type]);

  useEffect(() => {
    onRefresh();
  }, [onRefresh]);

  const TimeCertoCard = useCallback(({ img, nome, number }) => {
    return (
      <div className="supertime_tag">
        {img && <img src={img} />}
        <p>{nome}</p>
        <p>{number || ""}</p>
      </div>
    );
  }, []);

  const list = useMemo(() => {
    if (
      !resultados ||
      !resultados.draws ||
      !resultados.draws[0] ||
      !resultados.draws[0].previousDraws
    ) {
      return null;
    }

    const previousDraws = resultados.draws
      .reduce((draws, item) => draws.concat([item.previousDraws]), [])
      .flat();

    const draws = previousDraws.map((draw) => {
      return {
        date:
          moment(draw.timestamp).format("HH:mm") +
          " - " +
          moment(draw.timestamp).format("DD/MM"),
        raffled: draw.raffled,
        raffledPop: draw.raffledPop,
        img: draw.raffledImageUrl,
        nome: draw.raffledDescription,
        group: draw.raffledGroup,
        groupImg: getSuperTimeIcon(draw.raffledGroup),
      };
    });

    return draws;
  }, [resultados]);

  const groupedList = useMemo(() => {
    if (!list) return null;

    const object = list.reduce((result, currentItem) => {
      const { date, nome } = currentItem;
      const key = `${nome} | ${date}`;

      if (!date || !nome || !result[key]) {
        result[key] = {
          ...currentItem,
          raffledPop: [currentItem.raffledPop].flat()
        };
      } else {
        result[key].raffledPop.push(currentItem.raffledPop);
        result[key].raffledPop = result[key].raffledPop.flat();
      }

      return result;
    }, {});

    return Object.values(object);
  }, [list]);

  return (
    <div className="content-container">
      <h1>Selecione a data para ver os resultados</h1>

      <ResultContainer setDate={(date) => setCurrentDate(date)}>
        {list && list.length > 0 ? (
          <table>
            <thead>
              <tr>
                <th>{list[0].nome === "" ? "Data e Horário" : "Extração"}</th>
                <th>Sorteados</th>
              </tr>
            </thead>
            {isLoading ? (
              <tbody className="loading"></tbody>
            ) : (
              <tbody>
                {groupedList.map((draw) => (
                  <tr>
                    <td>{draw.nome === "" ? draw.date : draw.nome}</td>

                    <td>
                      {type === "concurso" && (
                        <div className="result_ball-container">
                          {draw.raffled.map((raffle) => (
                            <div>
                              {raffle}
                              <img src={"assets/icons/ball.svg"} />
                            </div>
                          ))}
                        </div>
                      )}

                      {type === "super-time" && (
                        <div className="resultados_super-time-container">
                          <TimeCertoCard
                            img={draw.img}
                            nome={draw.nome}
                            number={draw.raffled[0].toString().padStart(2, "0")}
                          />
                          <TimeCertoCard
                            img={draw.groupImg}
                            nome={draw.group}
                          />
                        </div>
                      )}

                      {["loteria-popular", "rifa"].includes(type) && (
                        <div className="tags-container">
                          {draw.raffledPop.map((pop, i) => (
                            <span className="result-tag" key={pop}>
                              {`${i + 1}º - `} {pop}
                            </span>
                          ))}
                        </div>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            )}
          </table>
        ) : (
          <div className="no-results">Nenhum prêmio neste dia.</div>
        )}
      </ResultContainer>
    </div>
  );
}

export default Resultados;



// WEBPACK FOOTER //
// ./src/newDesign/components/resultados.jsx